// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3GcNS","detailsBorder":"styles_detailsBorder__2PsZn"};